import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Sigma } from "lucide-react";
import { ALGEBRA_SUB_OPS } from "../lib/constants";
import { ProfileBar } from "../components/ProfileBar";
import { PageShell } from "../components/PageShell";
import { ClayButton } from "../components/ClayButton";

export default function AlgebraSubSelect({ profile, onReset }) {
  const navigate = useNavigate();

  return (
    <PageShell>
      <ProfileBar profile={profile} onReset={onReset} />

      <div className="mt-6">
        <ClayButton variant="ghost" onClick={() => navigate("/secundaria")} data-testid="back-btn">
          <ArrowLeft className="w-5 h-5" strokeWidth={3} />
          Volver
        </ClayButton>
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mt-2">
        <div className="inline-flex items-center gap-3 rounded-full px-4 py-2 mb-4 bg-[#E9E3FF]">
          <span className="w-9 h-9 rounded-xl flex items-center justify-center bg-[#7B61FF]">
            <Sigma className="w-5 h-5 text-white" strokeWidth={3} />
          </span>
          <span className="font-bold text-base text-[#3D2EA0]">Álgebra básica</span>
        </div>

        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#1C1C1E] mb-2">
          ¿Qué quieres practicar?
        </h2>
        <p className="text-base sm:text-lg text-[#5C5C60] mb-6 sm:mb-8 max-w-xl">
          Elige un tipo de ejercicio y luego un nivel.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6" data-testid="alg-sub-grid">
          {ALGEBRA_SUB_OPS.map((sub, i) => (
            <motion.button
              key={sub.id}
              onClick={() => navigate(`/secundaria/algebra/${sub.id}`)}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08, type: "spring", bounce: 0.4 }}
              whileHover={{ y: -4 }}
              whileTap={{ scale: 0.97 }}
              className="clay-btn relative rounded-[2rem] p-5 sm:p-6 text-left bg-white border-4 border-b-[8px] active:border-b-4 overflow-hidden"
              style={{ borderColor: sub.colorLight, borderBottomColor: sub.color }}
              data-testid={`alg-sub-${sub.id}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div
                  className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center font-heading text-xl sm:text-2xl font-bold text-white"
                  style={{ backgroundColor: sub.color }}
                >
                  {sub.symbol}
                </div>
                <span
                  className="font-heading text-base sm:text-lg font-bold px-3 py-1 rounded-full"
                  style={{ backgroundColor: sub.colorLight, color: sub.borderDark }}
                >
                  {sub.sample}
                </span>
              </div>
              <h3 className="font-heading text-2xl sm:text-3xl font-bold text-[#1C1C1E]">
                {sub.short}
              </h3>
              <p className="text-sm sm:text-base text-[#5C5C60]">{sub.description}</p>
            </motion.button>
          ))}
        </div>
      </motion.div>
    </PageShell>
  );
}
